import axios from "axios";
import config from "config";

const API_URL = config.TRAFFIC;

export async function fetchBusStation() {
  const displayMessage = (d) => {
    if (!d) return;
    const label = d.label_en ? d.label_en : "";

    const message = `<div>
        <p>${label}</p>
      </div>`;

    return message;
  };

  try {
      const response = await axios.get(`${API_URL}/bus_stop_geom`, {
      headers: {
        "Content-Type": "application/json",
        "accept-profile": "oasth",
      },
      });
    


    const features = response.data.map((data, key) => ({
      id: 10000 + key,
      type: "Feature",
      properties: {
        name: data.label_en,
        // icon: getEventIcon(data.category.id),
        displayMessage: displayMessage(data),
      },
      geometry: {
        type: "Point",
        coordinates: data.geom,
      },
    }));

    return {
      type: "FeatureCollection",
      features,
    };
  } catch (error) {
    console.error("Error fetching data:", error);
    return { data: null, error: error.message || "Unknown error" };
  }
}


export async function fetchMetroStation() {
  const displayMessage = (d) => {
    if (!d) return;
    const label = d.ENAME ? d.ENAME : "";

    const message = `<div>
        <p>${label}</p>
      </div>`;

    return message;
  };

  try {
    const response = await axios.get(`${API_URL}/metro_stop_geom`, {
      headers: {
        "Content-Type": "application/json",
        "accept-profile": "infohub",
      },
    });


    const features = response.data.map((data, key) => ({
      id: 20000 + key,
      type: "Feature",
      properties: {
        name: data.label_en,
        // icon: getEventIcon(data.category.id),
        displayMessage: displayMessage(data),
      },
      geometry: {
        type: "Point",
        coordinates: data.geom,
      },
    }));

    return {
      type: "FeatureCollection",
      features,
    };
  } catch (error) {
    console.error("Error fetching data:", error);
    return { data: null, error: error.message || "Unknown error" };
  }
}
